import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ButtonLink, CustomIcon } from '@components/shared';
import { useSelector } from 'react-redux';
import { StoreState } from '@root/types';
import routes from '@root/routes';
import classNames from 'classnames';
import EmptyStateSvg from './empty-state.svg';
import s from './EmptyState.module.less';

const EmptyState = () => {
  const { t } = useTranslation('tourbook');
  const flags = useFlags();
  const userMarketSlug = useSelector((state: StoreState) => state.currentUser?.marketSlug);

  return (
    <div className={classNames(s.container, s.text, !flags['update-empty-state'] && s.deprecated)}>
      {flags['update-empty-state'] ? <EmptyStateSvg /> : null}
      <h2 className={s.headerText}>{t('showEmptyState.header')}</h2>
      {!flags['update-empty-state'] ? (
        <CustomIcon
          className={s.icon}
          type="tourbook-with-no-listings"
          title="No listings in tourbook"
        />
      ) : null}
      <div className={s.bodyText}>{t('showEmptyState.cta')}</div>
      <ButtonLink
        className={s.searchButton}
        type="primary"
        href={
          flags['search-redesign']
            ? routes.search(userMarketSlug as string)
            : routes.listingSearch()
        }
        size="large"
      >
        {t('showEmptyState.searchButton')}
      </ButtonLink>
    </div>
  );
};

export default EmptyState;
